import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {connect, useDispatch, useSelector} from 'react-redux';
import { Link } from 'react-router-dom';
import {
    Icon, Image, Label, Menu,
} from 'semantic-ui-react';
import { openMenu } from './actions';
import { getCart } from '../../views/Cart/reducer';
import './../NavTopBar/NavBar.css'

import TicketIcon from "./../../icons/ticket-icon.png";
import UsersIcon from "./../../icons/users-icon.png";
import AccessIcon from "./../../icons/access-icon.png";
import MenuIcon from "./../../icons/menu-icon.png";
import UserIcon from "../../icons/user-icon.png";
import EventsIcon from "./../../icons/calendar-events-icon.png";
import AgentsIcon from "./../../icons/counter-agents-icon.png";
import {isMenuVisible} from "./reducer";
import {isSearchVisible} from "../NavTopBar/reducer";
import {getLanguage} from "../LanguageModal/reducer";
import translations from "../LanguageModal/translations";
import {getUserData} from "../UserLogin/reducer";
import {getRolesAccess} from "../Roles/Roles";

export default function NavBottomBar(props) {
    const userData = useSelector((state) => getUserData(state.userLogin));
    const roleAccess = getRolesAccess(userData.roles);
    const { cart, wishlist, token } = props;
    const dispatch = useDispatch()
    const searchVisible = useSelector((state) => isSearchVisible(state.navtopbar));
    const visible = useSelector((state) => isMenuVisible(state.navbottombar));

    function getCartQuantity() {
        return cart.reduce((quantity, item) => item.quantity + quantity, 0);
    }

    function showSidebar(e) {
        //const { openMenu: open } = props;
        e.stopPropagation();
        dispatch(openMenu())
        //console.log(visible)
    }
    const language = useSelector(getLanguage);
    const t = (key) => {
        const languageString = language[0]+language[1];
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };


    return (
        <>
            {searchVisible ? '' : (
                <Menu
                    fluid
                    secondary
                    className="nav-bottom-bar"
                    fixed="bottom"
                    icon="labeled"
                    inverted
                >
                    <Link to="/" className="shop-link">
                        <Menu.Item className="shop-icon-item bottom">
                            <Image src={TicketIcon} size="small" className="shop-icon-bottom" />
                            <div className='menu-text'>{t('tickets')}</div>
                        </Menu.Item>
                    </Link>
                    {(roleAccess.pageUsers && token) && <Link to="/orders" className="shop-link">
                        <Menu.Item className="shop-icon-item bottom">
                            <Image src={UsersIcon} size="small" className="shop-icon-bottom" />
                            <div className='menu-text'>{t('users')}</div>
                        </Menu.Item>
                    </Link>}
                    {(roleAccess.pageCounter && token) && <Link to="/counterparties" className="shop-link">
                        <Menu.Item className="shop-icon-item bottom">
                            <Image src={AgentsIcon} size="small" className="shop-icon-bottom" />
                            <div className='menu-text'>{t('agents')}</div>
                        </Menu.Item>
                    </Link>}
                    {(roleAccess.pageEvents && token) && <Link to="/events" className="shop-link">
                        <Menu.Item className="shop-icon-item bottom">
                            <Image src={AccessIcon} size="small" className="shop-icon-bottom" />
                            <div className='menu-text'>{t('events')}</div>
                        </Menu.Item>
                    </Link>}
                    {(roleAccess.pageOrg && token) && <Link to="/organizer" className="shop-link">
                        <Menu.Item className="shop-icon-item bottom">
                            <Image src={EventsIcon} size="small" className="shop-icon-bottom" />
                            <div className='menu-text'>{t('organizer')}</div>
                        </Menu.Item>
                    </Link>}
                    <Menu.Item className="shop-icon-item bottom" onClick={showSidebar}>
                        <Image src={MenuIcon} size="small" className="shop-icon-bottom" />
                        <div className='menu-text'>{t('menu')}</div>
                    </Menu.Item>
                </Menu>
            )}
        </>
    );
}

